import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite} from "gsap";
import {DjPsycho} from "../DjPsycho";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoBonusBuy extends PIXI.Container implements StageLayer {

    private _luckyDraw: PIXI.spine.Spine[] = [];
    private _attention: TimelineLite[] = [];
    private _collectorIndicator: PIXI.spine.Spine[] = [];

    constructor() {
        super();
        this.name = "DjPsychoBonusBuy";

        this.init();
    }

    public play(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        this._attention = [];

        tl.add(() => {
            // #156
            DjPsycho.soundPlayer.fadeMusic({
                name: "",
                duration: 50,
                to: 0
            });
            DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_BUY_METER_MUSIC);

            this.alpha = 1;
            this.visible = true;
            DjPsycho.blackBgView.showBlackBg();
        }, 0);
        for (let ctr: number = 1; ctr < 6; ctr++) {
            const item: PIXI.spine.Spine = this._luckyDraw[ctr - 1],
                loopTl: TimelineLite = new TimelineLite();

            loopTl.add([
                () => {
                    item.visible = true;
                },
                DjPsycho.createTimelineForAnimation(item, 0, "Collector_" + ctr + "_Loop", true)
            ], 0);
            this._attention.push(loopTl);
        }

        tl.to(this, {
            duration: 0.8
        }, 0);

        return tl;
    }

    public indicateLuckyDraw(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            activeColorsForFS: boolean[] = [...DjPsycho.model.gameData.activeColorsForFS].reverse();

        activeColorsForFS.forEach((value: boolean, idx: number) => {
            tl.add(() => {
                this._attention[4 - idx].pause();
                this._attention[4 - idx].kill();
            });
            const item: PIXI.spine.Spine = this._luckyDraw[4 - idx];

            // #156
            if (idx === (activeColorsForFS.length - 1)) {
                tl.add(() => {
                    DjPsycho.soundPlayer.stopSound(DjPsychoSound.FS_BUY_METER_MUSIC);
                    DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_BUY_METER_MUSIC_ENDS);
                });
            }

            if (value) {
                tl.add([
                    () => {
                        // #156
                        DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_BUY_METER_FILL);
                    },
                    DjPsycho.createTimelineForAnimation(item, 0, "Collector_" + `${5 - idx}` + "_Yes", false)
                ]);
            } else {
                tl.add([
                    () => {
                        // #156
                        DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_BUY_METER_EMPTY);
                    },
                    DjPsycho.createTimelineForAnimation(item, 0, "Collector_" + `${5 - idx}` + "_No", false)
                ]);
            }
        });

        return tl;
    }

    public playCollectorIndicatorSpine(): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            activeColorsForFS: boolean[] = [...DjPsycho.model.gameData.activeColorsForFS];

        activeColorsForFS.forEach((value: boolean, idx: number) => {
            const collectorIndicator: PIXI.spine.Spine = this._collectorIndicator[idx];
            if (value) {
                tl.add([
                    () => {
                        collectorIndicator.visible = true;
                    },
                    DjPsycho.createTimelineForAnimation(collectorIndicator, 0, "Indicator_" + `${idx + 1}`, false)
                ], 0);
            }
        });
        tl.to(this, {
            alpha: 0,
            duration: 0.2
        });
        tl.add(() => {
            this.visible = false;
        });

        return tl;
    }

    // #107
    public stopAll(): void {
        if (this.visible) {
            this._attention.forEach((tl: TimelineLite) => {
                tl.pause();
                tl.kill();
            });

            this._attention = [];

            this.visible = false;

            DjPsycho.blackBgView.onComplete();

            DjPsycho.xBetView.removeButton(true);
        } else if (DjPsycho.sfsBought) {
            DjPsycho.xBetView.removeButton(true);
        }
    }

    private init(): void {
        const totalColors: number = 5,
            baseY: number = 20,
            yFactor: number = 108;

        let luckyDraw: PIXI.spine.Spine,
            collectorIndicator: PIXI.spine.Spine;

        for (let ctr: number = 1; ctr <= totalColors; ctr++) {
            luckyDraw = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("luckyDraw"));
            luckyDraw.visible = false;
            luckyDraw.position.set(360, baseY + (ctr * yFactor));
            this._luckyDraw.push(luckyDraw);
            this.addChild(luckyDraw);
        }

        for (let ctr: number = 1; ctr <= totalColors; ctr++) {
            collectorIndicator = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("fsIndicatorSpine"));
            collectorIndicator.visible = false;
            collectorIndicator.scale.set(2);
            collectorIndicator.position.set(360, baseY + (ctr * yFactor));
            this._collectorIndicator.push(collectorIndicator);
            this.addChild(collectorIndicator);
        }

        this.visible = false;
    }
}